import { useEffect, useState } from "react";
import {
  AC_MASKED_LEFT,
  AC_MASKED_LEFT_NR,
  AC_MASKED_RIGHT,
  AC_MASKED_RIGHT_NR,
  AC_UNMASKED_LEFT,
  AC_UNMASKED_LEFT_NR,
  AC_UNMASKED_RIGHT,
  AC_UNMASKED_RIGHT_NR,
  BC_MASKED_LEFT,
  BC_MASKED_LEFT_NR,
  BC_MASKED_RIGHT,
  BC_MASKED_RIGHT_NR,
  BC_UNMASKED_LEFT,
  BC_UNMASKED_LEFT_NR,
  BC_UNMASKED_RIGHT,
  BC_UNMASKED_RIGHT_NR,
  MCL_LEFT,
  MCL_RIGHT,
  SOUNDFIELD_AIDED_LEFT,
  SOUNDFIELD_AIDED_LEFT_NR,
  SOUNDFIELD_AIDED_RIGHT,
  SOUNDFIELD_AIDED_RIGHT_NR,
  SOUNDFIELD_UNAIDED_LEFT,
  SOUNDFIELD_UNAIDED_LEFT_NR,
  SOUNDFIELD_UNAIDED_RIGHT,
  SOUNDFIELD_UNAIDED_RIGHT_NR,
  UCL_LEFT,
  UCL_LEFT_NR,
  UCL_RIGHT,
  UCL_RIGHT_NR,
} from "./utils";

import blueArrowRightImage from "assets/images/pure-tone-audiogram-v2/blueArrowRightImage.svg";
import blueBracketImage from "assets/images/pure-tone-audiogram-v2/blueBracketImage.svg";
import blueSquareImage from "assets/images/pure-tone-audiogram-v2/blueSquareImage.svg";

//src/assets/images/
import blueXImage from "assets/images/pure-tone-audiogram-v2/blueXImage.svg";
import redArrowLeftImage from "assets/images/pure-tone-audiogram-v2/redArrowLeftImage.svg";
import redBracketImage from "assets/images/pure-tone-audiogram-v2/redBracketImage.svg";
import redCircleImage from "assets/images/pure-tone-audiogram-v2/redCircleImage.svg";
import redTriangleImage from "assets/images/pure-tone-audiogram-v2/redTriangleImage.svg";
import mclRightImage from "assets/images/pure-tone-audiogram-v2/mclRightImage.svg";
import mclLeftImage from "assets/images/pure-tone-audiogram-v2/mclLeftImage.svg";
import uclLeftImage from "assets/images/pure-tone-audiogram-v2/uclLeftImage.svg";
import uclLeftNRImage from "assets/images/pure-tone-audiogram-v2/uclLeftNR.svg";
import uclRightImage from "assets/images/pure-tone-audiogram-v2/uclRightImage.svg";
import uclRightNRImage from "assets/images/pure-tone-audiogram-v2/uclRightNR.svg";
import aidedLeftImage from "assets/images/pure-tone-audiogram-v2/aidedLeftImage.svg";
import aidedRightImage from "assets/images/pure-tone-audiogram-v2/aidedRightImage.svg";
import aidedImage from "assets/images/pure-tone-audiogram-v2/aidedImage.svg";

import unaidedLeftImage from "assets/images/pure-tone-audiogram-v2/unaidedLeftImage.svg";
import unaidedRightImage from "assets/images/pure-tone-audiogram-v2/unaidedRightImage.svg";
import unaidedImage from "assets/images/pure-tone-audiogram-v2/unaidedImage.svg";
import blueXNRImage from "assets/images/pure-tone-audiogram-v2/blueXNR.svg";
import aidedLeftNRImage from "assets/images/pure-tone-audiogram-v2/aidedLeftNR.svg";
import aidedRightNRImage from "assets/images/pure-tone-audiogram-v2/aidedRightNR.svg";
import unaidedLeftNRImage from "assets/images/pure-tone-audiogram-v2/unaidedLeftNR.svg";
import unaidedRightNRImage from "assets/images/pure-tone-audiogram-v2/unaidedRightNR.svg";
import redArrowNRImage from "assets/images/pure-tone-audiogram-v2/redArrowNR.svg";
import redBracketNRImage from "assets/images/pure-tone-audiogram-v2/redBracketNR.svg";
import redCircleNRImage from "assets/images/pure-tone-audiogram-v2/redCircleNR.svg";
import redTriangleNRImage from "assets/images/pure-tone-audiogram-v2/redTriangleNR.svg";
import blueArrowNRImage from "assets/images/pure-tone-audiogram-v2/blueArrowNR.svg";
import blueBracketNRImage from "assets/images/pure-tone-audiogram-v2/blueBracketNR.svg";
import blueSquareNRImage from "assets/images/pure-tone-audiogram-v2/blueSquareNR.svg";

export const pureToneImageArray = [
  blueArrowRightImage,
  blueBracketImage,
  blueSquareImage,
  blueXImage,
  redArrowLeftImage,
  redBracketImage,
  redCircleImage,
  redTriangleImage,
  mclRightImage,
  mclLeftImage,
  uclLeftImage,
  uclRightImage,
  aidedLeftImage,
  aidedRightImage,
  unaidedLeftImage,
  unaidedRightImage,
  blueArrowNRImage,
  blueBracketNRImage,
  blueXNRImage,
  blueSquareNRImage,
  redArrowNRImage,
  redBracketNRImage,
  redCircleNRImage,
  redTriangleNRImage,
  aidedLeftNRImage,
  aidedRightNRImage,
  unaidedLeftNRImage,
  unaidedRightNRImage,
  aidedImage,    // index 28
  unaidedImage,  // index 29
  uclLeftNRImage,  // index 30
  uclRightNRImage, // index 31
];

export default function usePureToneImages() {
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [pointStyles, setPointStyles] = useState<any>({});
  useEffect(() => {
    Promise.all(
      pureToneImageArray.map((imageSrc) => {
        return new Promise((resolve, reject) => {
          const img = new Image(30, 30);
          img.src = imageSrc;
          img.onload = () => resolve(img);
          img.onerror = reject;
        });
      })
    ).then((images) => {
      setPointStyles({
        [BC_UNMASKED_LEFT]: images[0],
        [BC_MASKED_LEFT]: images[1],
        [AC_UNMASKED_LEFT]: images[3],
        [AC_MASKED_LEFT]: images[2],
        [BC_UNMASKED_RIGHT]: images[4],
        [BC_MASKED_RIGHT]: images[5],
        [AC_UNMASKED_RIGHT]: images[6],
        [AC_MASKED_RIGHT]: images[7],
        [MCL_RIGHT]: images[8],
        [MCL_LEFT]: images[9],
        [UCL_LEFT]: images[10],
        [UCL_RIGHT]: images[11],
        [SOUNDFIELD_AIDED_LEFT]: images[28],
        [SOUNDFIELD_AIDED_RIGHT]: images[28],
        [SOUNDFIELD_UNAIDED_LEFT]: images[29],
        [SOUNDFIELD_UNAIDED_RIGHT]: images[29],
        [BC_UNMASKED_LEFT_NR]: images[16],
        [BC_MASKED_LEFT_NR]: images[17],
        [AC_UNMASKED_LEFT_NR]: images[18],
        [AC_MASKED_LEFT_NR]: images[19],
        [BC_UNMASKED_RIGHT_NR]: images[20],
        [BC_MASKED_RIGHT_NR]: images[21],
        [AC_UNMASKED_RIGHT_NR]: images[22],
        [AC_MASKED_RIGHT_NR]: images[23],
        [SOUNDFIELD_AIDED_LEFT_NR]: images[24],
        [SOUNDFIELD_AIDED_RIGHT_NR]: images[25],
        [SOUNDFIELD_UNAIDED_LEFT_NR]: images[26],
        [SOUNDFIELD_UNAIDED_RIGHT_NR]: images[27],
        [UCL_LEFT_NR]: images[30],
        [UCL_RIGHT_NR]: images[31],
      });
      setImagesLoaded(true);
    });
  }, []);
  return { imagesLoaded, pointStyles };
}
